const selectors = {
  productContainer: document.querySelector('.product-details-wrapper'),
  addToCartCTA: document.querySelector('.addtocart-cta'),
  addToCartContainer: document.querySelector('.addtocart-container'),
  customGiftOption: document.querySelector('#custom_denomination'),
  stickyBar: document.querySelector('[data-pdp-sticky-bar]')
};

class TemplateProductJS {
  constructor() {
    this.initStickyBar();
    this.listenVariantChange();
  }

  initStickyBar() {
    const trigger = document.querySelector('.atc-wrapper');
    if (!trigger || !selectors.stickyBar) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          selectors.stickyBar.classList.remove('show');
        } else {
          const rect = trigger.getBoundingClientRect();
          if (rect.bottom < 0) {
            selectors.stickyBar.classList.add('show');
          } else {
            selectors.stickyBar.classList.remove('show');
          }
        }
      });
    });

    observer.observe(trigger);

    const stickyAddBtn = selectors.stickyBar.querySelector('[data-pdp-sticky-add]');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', () => {
        const addBtn = document.querySelector('.addtocart-cta button[name="add"]');
        if (addBtn && !addBtn.disabled) {
          stickyAddBtn.classList.add('loading');
          stickyAddBtn.setAttribute('disabled', true);
          addBtn.click();

          const checkLoading = setInterval(() => {
            if (!addBtn.classList.contains('loading')) {
              stickyAddBtn.classList.remove('loading');
              stickyAddBtn.removeAttribute('disabled');
              clearInterval(checkLoading);
            }
          }, 100);
        }
      });
    }
  }

  listenVariantChange() {
    if (!selectors.stickyBar) return;

    document.addEventListener('variant:changed', () => {
      const variant = window.globalVariables?.product?.currentVariant;
      if (!variant) return;

      const moneyFormat = window.globalVariables?.money_format;
      if (!moneyFormat) return;

      const priceText = Utility.formatMoney(variant.price, moneyFormat);

      selectors.stickyBar.querySelectorAll('[data-pdp-sticky-price], [data-pdp-sticky-price-mobile]').forEach(el => {
        el.textContent = priceText;
      });

      const compareEls = selectors.stickyBar.querySelectorAll('[data-pdp-sticky-compare-price]');
      compareEls.forEach(el => {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          el.textContent = Utility.formatMoney(variant.compare_at_price, moneyFormat);
          el.classList.remove('d-none');
        } else {
          el.classList.add('d-none');
        }
      });

      const stickyAddBtn = selectors.stickyBar.querySelector('[data-pdp-sticky-add]');
      if (stickyAddBtn) {
        stickyAddBtn.disabled = !variant.available;
        const addTexts = stickyAddBtn.querySelectorAll('.add-text');
        const addToCartStr = window.variantStrings?.addToCart || 'Add to cart';
        const soldOutStr = window.variantStrings?.soldOut || 'Sold out';
        addTexts.forEach(el => {
          const priceMobileEl = el.querySelector('[data-pdp-sticky-price-mobile]');
          if (variant.available) {
            if (priceMobileEl) {
              el.innerHTML = addToCartStr + ' - <span data-pdp-sticky-price-mobile>' + priceText + '</span>';
            } else {
              el.textContent = addToCartStr;
            }
          } else {
            el.textContent = soldOutStr;
          }
        });
      }

      const imgEl = selectors.stickyBar.querySelector('.pdp-sticky-image img');
      if (imgEl && variant.featured_image) {
        imgEl.src = variant.featured_image.src;
      }
    });
  }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
